<template>
  <v-container>
    <v-row>
      <v-toolbar flat>
        <v-toolbar-title>Early Termination Fee (ETF)</v-toolbar-title>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete
          :search-input.sync="search"
          label="Customer Number"
          :items="items"
          outlined
          v-model="customerNumber"
          placeholder=" "
          @change="retrieveService(customerNumber)"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="8">
        <v-autocomplete
          label="Services"
          :items="filteredServices"
          outlined
          v-model="service"
          item-text="text"
          item-value="value"
          placeholder=" "
          :loading="isLoading"
          no-data-text="No data available"
          @change="fetchServiceItem(service)"
          return-object
        >
          <p class="ml-5" slot="prepend-item" v-if="isLoading">
            <v-progress-circular
              indeterminate
              color="primary"
              class="mb-0"
            ></v-progress-circular>
            Fetching data please wait. . .
          </p>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6" class="pt-0 pb-0">
        <v-dialog
          ref="requestDateDialog"
          v-model="requestDateModal"
          :return-value.sync="startDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              prepend-inner-icon="event"
              readonly
              v-on="on"
              label="Request Date"
              outlined
              @change="checkForm"
              :value="dateFormat(startDate)"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="requestDateModal = false"
              >Cancel</v-btn
            >
            <v-btn
              color="primary"
              @click="$refs.requestDateDialog.save(startDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="12" md="6" class="pt-0 pb-0">
        <v-dialog
          ref="endDateDialog"
          v-model="endDateModal"
          :return-value.sync="endDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              prepend-inner-icon="event"
              readonly
              v-on="on"
              label="End Date"
              outlined
              @change="checkForm"
              :value="dateFormat(endDate)"
              :disabled="true"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="endDateModal = false"
              >Cancel</v-btn
            >
            <v-btn color="primary" @click="$refs.endDateDialog.save(endDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="5">
        <v-text-field
          label="Plan Fee"
          type="number"
          required
          prepend-inner-icon="attach_money"
          :disabled="!service"
          v-model="planFee"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="7">
        <v-chip class="font-weight-bold">Total ETF</v-chip>
        <span class="font-weight-bold"
          >${{ earlyTerminationFee > 0 ? earlyTerminationFee : 0.0 }} (excluding
          GST) / ${{
            terminationFeeGst > 0 ? terminationFeeGst : 0.0
          }}
          (including GST)</span
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "EarlyTerminationView",
  data() {
    return {
      items: [],
      customerNumber: null,
      search: null,
      isLoading: false,
      service: null,
      serviceItems: [],
      startDate: null,
      requestDate: null,
      requestDateModal: false,
      endDateModal: false,
      endDate: null,
      planFee: null
    };
  },
  computed: {
    filteredServices() {
      return this.serviceItems
        .filter(x => x.contractEnd.length > 0 && x.released.length == 0)
        .map(({ plan, name, service, added, contractEnd, group }) => ({
          text: plan + " - " + name,
          value: service,
          added: added,
          contractEnd: contractEnd,
          group: group
        }));
    },
    terminationFeeGst() {
      return parseFloat(this.earlyTerminationFee * 1.1).toFixed(2);
    },
    earlyTerminationFee() {
      let total = 0;
      const serviceType = [
        "fibre",
        "afib",
        "mbea",
        "mnf sip",
        "nbn ent",
        "mnf nbn"
      ];
      const rq = new Date(this.startDate);
      const ed = new Date(this.endDate);
      let planFee = this.planFee;
      let endDateDaysLeft = this.getDayDiff(
        new Date(ed.getFullYear(), ed.getMonth(), 0),
        ed
      );
      let daysLeft = 0;
      if (
        rq.getMonth() + "" + rq.getFullYear() ==
        ed.getMonth() + "" + ed.getFullYear()
      ) {
        daysLeft = this.getDayDiff(rq, ed) + 2;
        endDateDaysLeft = 0;
      } else {
        daysLeft = Number(31 - rq.getDate()) + 1;
      }
      endDateDaysLeft = this.getDayDiff(
        new Date(ed.getFullYear(), ed.getMonth(), 0),
        ed
      );

      let remainingMonths = 0;

      remainingMonths = this.countRemainingMonths(rq, ed);

      if (this.service)
        if (this.service.group.toLowerCase() != "vonex-nextel")
          if (
            serviceType.every(x => !this.service.text.toLowerCase().includes(x))
          )
            planFee = Math.round((planFee / 2) * 100)/100

      const calculatedPlanFee = planFee / 31

      const combinedPlanDays = Number(parseFloat((calculatedPlanFee * daysLeft)).toFixed(2)) + Number(parseFloat((calculatedPlanFee * endDateDaysLeft)).toFixed(2));

      total += combinedPlanDays + Number(parseFloat(planFee * (remainingMonths - 1)).toFixed(2))

      return Math.round(total * 100 )/100;
    }
  },
  methods: {
    ...mapActions("reminders", [
      "RetrieveCustomer",
      "RequestCustomerDispute",
      "SendCustomerDispute",
      "getServices"
    ]),
    countRemainingMonths(startDate, endDate) {
      return (
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        endDate.getMonth() -
        startDate.getMonth()
      );
    },

    retrieveService(customerNumber) {
      this.isLoading = true;
      this.serviceItems = [];
      this.endDate = null;
      this.startDate = null;
      this.planFee = null;
      this.getServices(customerNumber).then(data => {
        if (data.length > 0) {
          this.serviceItems = data;
          this.isLoading = false;
        }
      });
    },
    dateFormat(date) {
      if (!date) return "";

      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    checkForm() {
      if (!this.customerNumber) {
        this.error = true;
      }
    },
    fetchServiceItem(data) {
      this.endDate = data.contractEnd;
      this.startDate = this.dateFormat(new Date());
    },
    getDayDiff(startDate, endDate) {
      const msInDay = 24 * 60 * 60 * 1000;

      return Math.round(Math.abs(endDate - startDate) / msInDay);
    },
  },
  watch: {
    search(val) {
      this.RetrieveCustomer(val)
        .then(res => {
          this.items = res;
        })
        .catch(err => {})
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style lang="scss" scoped></style>
